module.exports = __webpack_public_path__ + "static/yeni-caddy-1760403013b1fdd127865f7166c47368.jpg";